/**
 * Created by mady on 08-06-2017.
 */
(function ($, DGS) {
  "use strict";

  DGS.useCustomSelect();
})(jQuery, window.DGS);